import React, { CSSProperties, ReactNode } from "react";
import {
  CollisionDetection,
  closestCenter,
  pointerWithin,
} from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export const gridCollisionDetection: CollisionDetection = (args) => {
  const pointerCollisions = pointerWithin(args);
  if (pointerCollisions.length > 0) {
    return pointerCollisions;
  }
  return closestCenter(args);
};

interface SortableGridItemProps {
  id: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

const SortableGridItem: React.FC<SortableGridItemProps> = ({
  id,
  className,
  style,
  children,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`touch-none ${className ?? ""}`}
      style={{
        ...style,
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? 20 : style?.zIndex,
        opacity: isDragging ? 0.8 : style?.opacity,
      }}
      {...attributes}
      {...listeners}
    >
      {children}
    </div>
  );
};

export default SortableGridItem;
